module.exports = __webpack_public_path__ + "static/media/js.724573b7.svg";